import { useQuery } from 'react-query';
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";

export function useApproveZoomAuth(url: string, options: object = {}) {
  const http = useHttpClient();

  return useQuery({
    ...options,
    queryKey: ['useApproveZoomAuth', url],
    queryFn: async () => {
      const response = await http.request({
        method: 'get',
        url,
      });

      return response.data;
    },
  });
}